"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shadows = {
    "none": "none",
    "sm": "0 calc(0.1rem * var(--voca-rem-multiplier)) calc(0.4rem * var(--voca-rem-multiplier)) rgba(0, 0, 0, 0.1)",
    "md": "0 calc(0.4rem * var(--voca-rem-multiplier)) calc(1.2rem * var(--voca-rem-multiplier)) rgba(0, 0, 0, 0.1)",
    "lg": "0 calc(1.2rem * var(--voca-rem-multiplier)) calc(2.4rem * var(--voca-rem-multiplier)) rgba(0, 0, 0, 0.1)"
};
exports.default = shadows;
